module.exports = __webpack_public_path__ + "img/logo.5eb18a11.png";